
class locale {
    static getCurrentLanguage() {
        return (window.navigator.languages && window.navigator.languages[0]) || window.navigator.language
    }
}

export default locale


// WEBPACK FOOTER //
// ./src/utility/Locale.js